import type { TFormProps } from "@/ui/components/form/Form";
import type { TInputProps } from "@/ui/components/form/Input";
import type { TButtonProps } from "@/ui/components/primitives/Button";
import type { SubmitEventHandler } from "react";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const LOGIN_DEFAULTS = {
  noValidate: true,
} satisfies Pick<TLoginProps, "noValidate">;

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TLoginInputProps = Omit<
  TInputProps,
  | "aria-describedby"
  | "defaultValue"
  | "id"
  | "name"
  | "onBlur"
  | "onChange"
  | "type"
  | "value"
> & {
  value: string;
  onValueChange: (value: string) => void;
  onBlur?: () => void;
};

export type TLoginSubmitProps = Omit<
  TButtonProps,
  "children" | "type"
> & {
  label: string;
};

export type TLoginProps = Omit<
  TFormProps,
  "onSubmit"
> & {
  email: TLoginInputProps;
  password: TLoginInputProps;
  submit: TLoginSubmitProps;
  onSubmit: SubmitEventHandler<HTMLFormElement>;
};
